import {Component, OnInit} from '@angular/core';
import {AdminService} from '../../../../service/admin.service';
import {Router} from '@angular/router';

/**
 * @class
 * @description This component is used to sign out the admin user.
 * @export
 * @name SignOutAdminPageComponent
 */
@Component({
  imports: [],
  selector: 'app-page-admin-sign-out',
  standalone: true,
  styleUrl: './sign-out.component.scss',
  templateUrl: './sign-out.component.html'
})
export class SignOutAdminPageComponent implements OnInit {

  /**
   * @description This method is used to sign out the admin user.
   * @memberof SignOutAdminPageComponent
   * @name SignOutAdminPageComponent#constructor
   * @param {AdminService} adminService The injected instance of the admin service provider.
   * @param {Router} router The injected instance of the router service provider.
   * @public
   */
  public constructor(
    /**
     * @description The injected instance of the admin service provider.
     * @memberof SignOutAdminPageComponent
     * @name SignOutAdminPageComponent#adminService
     * @private
     * @readonly
     * @type {AdminService}
     */
    private readonly adminService: AdminService,
    /**
     * @description The injected instance of the router service provider.
     * @memberof SignOutAdminPageComponent
     * @name SignOutAdminPageComponent#router
     * @private
     * @readonly
     * @type {Router}
     */
    private readonly router: Router
  ) {
  }

  /**
   * @abstract
   * @description This method gets called when the component is initialized.
   * @memberof SignOutAdminPageComponent
   * @method
   * @name SignOutAdminPageComponent#ngOnInit
   * @public
   * @returns {void}
   */
  public ngOnInit(): void {

    // Check for an authenticated administrator session then sign out.
    if (this.adminService.online()) this.adminService.signOut().subscribe({

      // Redirect to the sign-in page when the sign-out process is complete.
      complete: () => this.router.navigate(['/admin/sign-in']).then((): void => {})
    });

    // Redirect to the sign-in page when the administrator is not authenticated.
    else this.router.navigate(['/admin/sign-in']).then((): void => {});
  }
}
